import type { ApiType } from '../../../shared/schemas'
import type { FeaturesDto } from './features.h'

import { PasswordPolicyName } from '@setplex/tria-api'
import * as v from 'valibot'

export const FeaturesSchema = v.object({
  aiSearchAvailable: v.optional(v.boolean()),
  appearanceCustomizationEnabled: v.optional(v.boolean()),
  countryLocation: v.optional(
    v.object({ country: v.optional(v.string(), 'US') })
  ),
  facebookLoginEnabled: v.optional(v.boolean()),
  guestModeEnabled: v.optional(v.boolean()),
  pushNotificationEnabled: v.optional(v.boolean()),
  inAppCredentialsChangeEnabled: v.optional(v.boolean()),
  partnersProgramEnabled: v.optional(v.boolean()),
  registrationEnabled: v.optional(v.boolean()),
  resetPasswordEnabled: v.optional(v.boolean()),
  signInByQrCodeEnabled: v.optional(v.boolean()),
  signInWithPhoneEnabled: v.optional(v.boolean()),
  singInWithAppleEnabled: v.optional(v.boolean()),
  kidsModulesEnabled: v.optional(v.boolean()),
  passwordPolicy: v.optional(
    v.object({
      name: v.picklist([PasswordPolicyName.DEFAULT, PasswordPolicyName.STRONG]),
      pattern: v.string(),
    })
  ),
}) satisfies ApiType<FeaturesDto, any>
